import React, { useEffect, useState } from 'react';
import LoadingMain from '../../components/LoadingMain'; 
import * as contentful from 'contentful';

import ProfileIcon from "../../assets/profile.png";
import config from "../../config";
import PageList from './pagesList';


export default function RelatedArticles({entryIds}) {



    const [pages, setPages] = useState([]);
    const [includes, setIncludes] = useState({});
    const [loading, setLoading] = useState(false);
    const [errResponse, setErrResponse] = useState("");

    const author = {
        name: 'Sid Alwar',
        role: 'Co-Founder',
        href: '#'
    }
    

    const client = contentful.createClient(config.contentfulConfig);

  useEffect(() => {

    const fetchData = async () => {
      setLoading(true);
      client.getEntries({
        content_type: 'blog',
        'sys.id[in]': entryIds,
        include: 1
      })
        .then((entries) => {
          if (entries["total"] === 0) {
            console.log("No related content found");
            setLoading(false)
            return;
          }
          return entries;
        })
        .then((entries) => {

          setPages(entries.items)
          setIncludes(entries.includes)
          setLoading(false); 
        })
        .catch((error) => {
          console.error('Error fetching data:', error);
          setLoading(false)
        })
        .finally(() => {
          setLoading(false); // Set loading state to false after fetch completes
        }
        );

    };

    fetchData();
  }, []);

  function getAssetImageUrl(id) {
    const asset = includes.Asset.find(asset => asset.sys.id === id);
    if (asset) {
      return `https:${asset.fields.file.url}`;
    }
    return null;
  }


  return (
    <div>
        {
            loading ? (
                <LoadingMain />
            ) : (
                <div className="bg-white">
                    <div className="">
                        <h2 className="mt-16 text-2xl font-bold tracking-tight text-gray-900">Related Articles</h2>
                        <div className="mt-4 grid grid-cols-1 gap-y-4 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-3 lg:gap-x-8">


                        <PageList pages={pages} includes={includes} />


                        </div>
                    </div>
                </div>
            )
        }
    </div>
  );
}





